import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { accentOf } from "@/components/calendar/palette";

// One chosen colour that follows the member across iMessages, AI Chat and Smart Tools.
const AccentContext = createContext({ theme: "electric", accent: accentOf("electric"), saveTheme: () => {} });

export const AccentProvider = ({ children }) => {
  const { user } = useAuth();
  const [theme, setTheme] = useState("electric");

  useEffect(() => {
    if (!user) return;
    api.get("/messages/theme")
      .then(({ data }) => setTheme(data.theme))
      .catch((e) => console.error("could not load my colour", e));
  }, [user]);

  const saveTheme = useCallback(async (next) => {
    setTheme(next);
    await api.put("/messages/theme", { theme: next });
  }, []);

  return (
    <AccentContext.Provider value={{ theme, accent: accentOf(theme), saveTheme }}>
      {children}
    </AccentContext.Provider>
  );
};

export const useAccent = () => useContext(AccentContext);
